const countOccurrences = (s: string, ch: string) => s.split(ch).length - 1;

// Characters that are almost always sentence punctuation rather than part of a URL.
const trailingPunctuation = new Set([
  ".",
  ",",
  ";",
  ":",
  "!",
  "?",
  "*",
  "_",
  "~",
]);

const closingToOpeningBracket: Record<string, string> = {
  ")": "(",
  "]": "[",
  "}": "{",
};

// URL matching in plain text greedily consumes closing brackets and sentence
// punctuation that follow the URL (e.g. "[https://x.com]" or markdown links
// like "[text](https://x.com)"). Strip trailing characters that are unlikely
// to be part of the actual URL: punctuation, and closing brackets with no
// matching opening bracket inside the URL.
export const trimUrlTrailingJunk = (url: string) => {
  let result = url;
  for (;;) {
    const last = result[result.length - 1];
    if (!last) return result;
    if (trailingPunctuation.has(last)) {
      result = result.slice(0, -1);
      continue;
    }
    const opening = closingToOpeningBracket[last];
    if (
      opening &&
      countOccurrences(result, last) > countOccurrences(result, opening)
    ) {
      result = result.slice(0, -1);
      continue;
    }
    return result;
  }
};
